/* RVerseCode theme helpers — small, dependency-free, deferred. */
(() => {
  // ---------- Mobile menu drawer ----------
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-rv-open]');
    if (opener) {
      const dlg = document.getElementById(opener.getAttribute('data-rv-open'));
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
        opener.setAttribute('aria-expanded', 'true');
        dlg.addEventListener('close', () => { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }, { once: true });
      }
      return;
    }
    const closer = e.target.closest('[data-rv-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    // click on backdrop closes
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('rv-drawer')) e.target.close();
  });

  // ---------- Cart count (header pill + mobile badge) ----------
  const renderCount = (n) => {
    document.querySelectorAll('[data-rv-cart-count]').forEach((el) => { el.textContent = String(n); });
    document.querySelectorAll('[data-rv-cart-badge]').forEach((el) => {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-rv-cart-label]').forEach((el) => {
      const tpl = el.getAttribute('data-rv-cart-label');
      el.setAttribute('aria-label', tpl.replace('[count]', n));
    });
  };
  const refreshCount = () =>
    fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json()).then((c) => renderCount(c.item_count)).catch(() => {});

  document.addEventListener('shopify:cart:lines-update', (event) => {
    const p = event.promise;
    if (p && typeof p.then === 'function') {
      p.then(({ cart, detail } = {}) => {
        const n = cart?.totalQuantity ?? detail?.itemCount;
        if (typeof n === 'number') renderCount(n); else refreshCount();
      }).catch(() => refreshCount());
    } else {
      refreshCount();
    }
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(); });

  // ---------- Newsletter: announce success politely ----------
  document.querySelectorAll('[data-rv-autofocus-msg]').forEach((el) => el.focus());

  window.RV = Object.assign(window.RV || {}, { refreshCartCount: refreshCount, renderCartCount: renderCount });
})();
